// extracted by mini-css-extract-plugin
module.exports = {"editPrompt":"editPrompt__QrgST","header":"header__hH7PG","textWrap":"textWrap__S2QAI","description":"description__z9I+a"};